import React from "react";
import {withStyles} from "material-ui/styles";
import {connect} from 'react-redux';
import {compose} from 'recompose';
import styles from "./styles";
import TextField from "material-ui/TextField";
import Title from "../ui/title";
import Content from "../ui/content";
import Context from "./context/";
import SearchBar from "../common/search";
import Toolbar from "./toolbar/";
import TestsRowLink from "../table/cells/testsRowLink";
import Table from "../table";
import NewDevice from "./new";
import ConfirmDialog from "../common/dialog/confirm";
import MuiPickersUtilsProvider
  from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import DatePicker from "material-ui-pickers/DatePicker";
import moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import Icon from "material-ui/Icon";
import Button from "material-ui/Button";
import Select from "material-ui/Select";
import {MenuItem} from "material-ui/Menu";
import Input from "material-ui/Input";
import {dateTimeFormatter, getISODateString} from "../../common/utils";
import {Switch} from "../ui/react-aria/Switch";
import {Heart} from "lucide-react";
import HealthCheckModal from "./modals/healthCheckModal";
import { APP_CONFIG } from "../../config";
import classnames from "classnames";

moment.suppressDeprecationWarnings = true;

const StatusSelect = props => {
  return (
    <Select
      value={props.value ? props.value : ""}
      onChange={props.onChange}
      input={
        <Input
          name="status"
          id="status"
          value={props.value ? props.value : "all"}
        />
      }
      fullWidth
    >
      <MenuItem
        value="all"> {props.translate("general_showall")} </MenuItem>{" "}
      <MenuItem value="true">
        {" "}
        {props.translate("general_registered")}{" "}
      </MenuItem>{" "}
      <MenuItem value="false">
        {" "}
        {props.translate("general_unregistered")}{" "}
      </MenuItem>{" "}
    </Select>
  );
};

const DeviceTypeSelect = props => {
  return (
    <Select
      value={props.value ? props.value : ""}
      onChange={props.onChange}
      input={
        <Input
          name="deviceType"
          id="deviceType"
          value={props.value ? props.value : "all"}
        />
      }
      fullWidth
    >
      <MenuItem
        value="all"> {props.translate("general_showall")} </MenuItem>{" "}
      {props.deviceTypes.map((deviceType, key) => {
        return (
          <MenuItem value={deviceType.name}>
            {" "}
            {props.translate(deviceType.name)}{" "}
          </MenuItem>
        );
      })}
    </Select>
  );
};

class Devices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDevices: [],
      selectAll: false,
      contextMenu: false,
      columns: null,
      modal: false,
      showConfirmDelete: false,
      filterable: false,
      selected: {},
      lastonlineSelectedDateTime: null,
      calibrationdueSelectedDateTime: null,
      lockDevice: {
        showModal: false,
        deviceId: null,
        isLocked: false,
      },
      healthCheckModal: {
        isOpen: false,
        selectedDevice: null,
      }
    };
    this.toggle = this.toggle.bind(this);
    this.toggleColumns = this.toggleColumns.bind(this);
    this.showNewDevice = this.showNewDevice.bind(this);
    this.hideNewDevice = this.hideNewDevice.bind(this);
    this.handleNewDevice = this.handleNewDevice.bind(this);
    this.inputtimer = null;
  }

  componentWillMount() {
    const {devices, pager, translate, deviceTypes, classes} = this.props;
    const {defaultColumns} = pager;
    const {
      filterable,
      lastonlineSelectedDateTime,
      calibrationdueSelectedDateTime
    } = this.state;
    let columns = [];
    const lockDEviceTypes = ['LanTEK IV', 'SignalTEK 10G', 'SignalTEK QT', 'SignalTEK QT Pro', 'NaviTEK III'];
    const healthCheckDeviceTypes = ['LanTEK IV', 'LanTEK IV-S', 'LanTEK IV-L'];

    if (this.props.hasLrpFreeFeatures) {
      // Add Health column as the first column
      columns.push({
      id: 'devicehealthstatus',
      Header: translate('adapter_health'),
      accessor: d => d.devicehealthstatus,
      toggle: false,
      show: true,
      display: true,
      filterable: false,
      cansearch: false,
      sortable: false,
      width: 70,
      Cell: o => {
        const row = o.original || o.row;
        if (!healthCheckDeviceTypes.includes(row.systemdevicetype)) {
          return null;
        }
        const status = row.devicehealthstatus;
        const checks = row.devicehealth || [];
        const colorMap = { green: '#4caf50', amber: '#ff9800', red: '#f44336' };
        const color = colorMap[status] || '#9e9e9e';

        const handleIconClick = () => {
          this.setState({
            healthCheckModal: {
              isOpen: true,
              selectedDevice: { ...row, deviceHealth: checks }
            }
          });
        };

        const wrapperClassName = classnames(this.props.classes.healthIconWrapper, this.props.classes.healthIcon);

        return (
          <div
            onClick={handleIconClick}
            className={wrapperClassName}
          >
            <Heart
              size={20}
              color={color}
            />
          </div>
        );
      }
      });
    }

    let allowedColumns = (APP_CONFIG.deviceLockEnabled && this.props.appSettingReducer?.activeFeatures?.some(f => f.featureName === 'geolocation_device_lock')) ? 
                         devices.columns : devices.columns.filter(c => c.field != "islocked");

    allowedColumns
      .sort((a, b) => a.order - b.order)
      .forEach(column => {
          if (!["paytstatus"].includes(column.field)) {
            if (column.field === "deviceserialno") {
              columns.push({
                id: column.field,
                accessor: d => d[column.field],
                Header: translate(column.field),
                toggle: false,
                show: true,
                display: column.display,
                Cell: o => {
                  return (
                    <React.Fragment>
                      <TestsRowLink
                        title={o.row[column.field]}
                        link={`/device/${o.row.id}?from=devices`}
                      />{" "}
                    </React.Fragment>
                  );
                },
                filterable: column.cansearch && filterable,
                cansearch: column.cansearch,
                sortable: column.cansort
              });
              if (this.props.hasLrpFreeFeatures) {
                columns.push({
                  id: "linkedadapterassets",
                  Header: translate('adapter_assets_title'),
                  accessor: d => d.id,
                  toggle: false,
                  show: true,
                  display: true,
                  filterable: false,
                  cansearch: false,
                  sortable: false,
                  width: 230,
                  Cell: o => this.renderLinkedAdapterCell(o.row.id)
                });
              }
            } else if (column.field === "systemdevicetype") {
              columns.push({
                id: column.field,
                accessor: d => d[column.field],
                Header: translate(column.field),
                toggle: false,
                show: true,
                display: column.display,
                filterable: column.cansearch && filterable,
                cansearch: column.cansearch,
                sortable: column.cansort,
                Filter: ({filter, onChange}) => (
                  <DeviceTypeSelect
                    onChange={event =>
                      onChange(
                        event.target.value === "all" ? "" : event.target.value
                      )
                    }
                    value={filter ? filter.value : "all"}
                    translate={translate}
                    deviceTypes={deviceTypes}
                  />
                )
              });
            } else if (
              column.field === "lastonline" ||
              column.field === "calibrationdue"
            ) {
              columns.push({
                id: column.field,
                Header: translate(column.field),
                accessor: d => d[column.field],
                show: defaultColumns.includes(column.field),
                Cell: o => {
                  return o.row[column.field]
                    ? dateTimeFormatter(o.row[column.field])
                    : "";
                },
                toggle: true,
                display: column.display,
                filterable: column.cansearch && filterable,
                cansearch: column.cansearch,
                sortable: column.cansort,
                width: 220,
                Filter: ({filter, onChange}) => {
                  return (
                    <React.Fragment>
                      <MuiPickersUtilsProvider
                        utils={MomentUtils}
                        moment={moment}
                      >
                        <div className="picker">
                          <DatePicker
                            value={null}
                            disableFuture
                            clearable
                            ampm={false}
                            format="DD/MM/YYYY"
                          />
                        </div>
                        {" "}
                      </MuiPickersUtilsProvider>{" "}
                    </React.Fragment>
                  );
                }
              });
            } else if (column.field === "registered") {
              columns.push({
                id: column.field,
                Header: translate(column.field),
                accessor: d => d[column.field],
                show: true,
                Cell: o => {
                  if (o.row[column.field]) {
                    return <span> {translate(`general_registered`)} </span>;
                  } else {
                    return <span> {translate(`general_unregistered`)} </span>;
                  }
                },
                filterable: column.cansearch && filterable,
                cansearch: column.cansearch,
                sortable: column.cansort,
                Filter: ({filter, onChange}) => (
                  <StatusSelect
                    onChange={event =>
                      onChange(
                        event.target.value === "all" ? "" : event.target.value
                      )
                    }
                    value={filter ? filter.value : "all"}
                    translate={translate}
                  />
                ),
                display: column.display
              });
            } else if (column.field === "islocked") {
              columns.push({
                id: column.field,
                accessor: d => d[column.field],
                Header: translate('lock_device'),
                toggle: false,
                show: true,
                display: column.display,
                Cell: o => {
                  return (
                    <React.Fragment>
                      {lockDEviceTypes.includes(o.row.systemdevicetype) ?
                      <div className={classes.lockedSwitch}>
                      <Switch isSelected={o.row[column.field]}
                        onChange={() => this.confirmToggleLocked(o.row)}
                      />
                      </div>
                      : null}
                    </React.Fragment>
                  );
                },
                filterable: column.cansearch && filterable,
                cansearch: column.cansearch,
                sortable: column.cansort
              });
            } else {
              columns.push({
                id: column.field,
                Header: translate(column.field),
                accessor: d => d[column.field],
                show: defaultColumns.includes(column.field),
                toggle: true,
                display: column.display,
                filterable: column.cansearch && filterable,
                cansearch: column.cansearch,
                sortable: column.cansort
              });
            }
          }
        }
      )
    ;

    this
      .setState({
        columns: columns
      });
  }

  setColumns(props) {
    const {
      filterable,
      lastonlineSelectedDateTime,
      calibrationdueSelectedDateTime,
      columns
    } = this.state;

    let col = columns.find(col => col.id === "lastonline");
    if (col) {
      col.Filter = ({filter, onChange}) => {
        return (
          <React.Fragment>
            <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
              <div className="picker">
                <DatePicker
                  value={lastonlineSelectedDateTime}
                  onChange={event => {
                    this.setState(
                      {
                        lastonlineSelectedDateTime: event ? event._d : null
                      },
                      () => {
                        if (!event) {
                          onChange("");
                          return "";
                        }
                        let date = getISODateString(event._d);
                        onChange(date);
                        return date;
                      }
                    );
                  }}
                  disableFuture
                  clearable
                  ampm={false}
                  format="DD/MM/YYYY"
                />
              </div>
              {" "}
            </MuiPickersUtilsProvider>{" "}
          </React.Fragment>
        );
      };
    }

    col = columns.find(col => col.id === "calibrationdue");
    if (col) {
      col.Filter = ({filter, onChange}) => {
        return (
          <React.Fragment>
            <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
              <div className="picker">
                <DatePicker
                  value={calibrationdueSelectedDateTime}
                  onChange={event => {
                    this.setState(
                      {
                        calibrationdueSelectedDateTime: event ? event._d : null
                      },
                      () => {
                        if (!event) {
                          onChange("");
                          return "";
                        }
                        let date = getISODateString(event._d);
                        onChange(date);
                        return date;
                      }
                    );
                  }}
                  disableFuture
                  clearable
                  ampm={false}
                  format="DD/MM/YYYY"
                />
              </div>
              {" "}
            </MuiPickersUtilsProvider>{" "}
          </React.Fragment>
        );
      };
    }

    this.setState({
      columns: columns
    });
  }

  componentWillReceiveProps(nextProps) {
    const props = {...nextProps};
    this.setColumns(props);
  }

  showNewDevice() {
    this.setState({
      modal: true
    });
  }

  hideNewDevice() {
    this.setState({
      modal: false
    });
  }

  handleNewDevice(device) {
    const oDevice = {
      deviceserialno: device.serialnumber,
      systemdevicetype: device.deviceType
    };
    this.props.addDevice(oDevice, this.props.pager);
    this.setState({
      modal: false
    });
  }

  showConfirmDelete = () => {
    this.setState({
      showConfirmDelete: true
    });
  };

  hideConfirmDel = () => {
    this.setState({
      showConfirmDelete: false
    });
  };

  del = () => {
    this.props
      .deleteDevice(this.state.selectedDevices[0].id, this.props.pager)
      .then(response => {
        this.setState({
          showConfirmDelete: false,
          selectAll: false,
          selectedDevices: []
        });
      });
  };

  showVnc = () => {
    this.props.deviceVNC();
  };

  confirmToggleLocked(row) {
    const { profile } = this.props;

    if (profile && parseInt(profile.customerid) !== row._original.organisationId) {
      return;
    }

    this.setState({
      lockDevice: {
        showModal: true,
        deviceId: row.id,
        isLocked: row.islocked,
      }
    });
  }

  hideLockDeviceModal() {
    this.setState({
      lockDevice: {
        showModal: false,
        deviceId: null,
        isLocked: false,
      }
    });
  }

  handleHealthCheckOpenChange = (isOpen) => {
    if (!isOpen) {
      this.setState({
        healthCheckModal: {
          isOpen: false,
          selectedDevice: null
        }
      });
    }
  };

  toggleLock() {
    const { updateDeviceLockStatus, refresh } = this.props;
    const { lockDevice } = this.state;

    this.hideLockDeviceModal();
    updateDeviceLockStatus(lockDevice.deviceId, lockDevice.isLocked)
      .then(() => {
        refresh();
      });
  }

  render() {
    const {
      classes,
      translate,
      devices,
      search,
      fetch,
      pager,
      user,
      deviceTypes,
      viewSwitcher,
      impersonating,
      softwareUpdate
    } = this.props;
    const {modal, selectedDevices, filterable, selected, lockDevice, healthCheckModal} = this.state;

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }
    const pageShellStyle = {
      paddingTop: margintop,
      boxSizing: "border-box",
      height: "100vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column"
    };

    const _selected = {...selected};
    const $modal = modal ? (
      <NewDevice
        close={this.hideNewDevice}
        translate={translate}
        submit={this.handleNewDevice}
        deviceTypes={deviceTypes}
      />
    ) : null;
    let $context = (
      <Context
        toggleColumns={this.toggleColumns}
        data={devices.data}
        translate={translate}
        columns={this.state.columns}
      />
    );

    let confirmDeleteText = translate("device_delete_confirm_text", {
      devicename:
        this.state.selectedDevices[0] &&
        this.state.selectedDevices[0].deviceserialno
          ? this.state.selectedDevices[0].deviceserialno
          : ""
    });
    const deleteEnabled =
      user && user.roles && user.roles.indexOf("clientuser") === -1;
    return (
      <div style={pageShellStyle}>
        <Title
          title={translate("general_devices")}
          toolbar={
            <Toolbar
              translate={translate}
              viewSwitcher={viewSwitcher}
              showDelete={!!(deleteEnabled && selectedDevices.length === 1)}
              toggle={() => this.toggle()}
              add={() => this.showNewDevice()}
              del={() => this.showConfirmDelete()}
              vnc={() => this.showVnc()}
              toggleFilters={this.toggleFilters}
            />
          }
        />{" "}
        <Content
          ctx={$context}
          open={this.state.contextMenu}
          toggle={() => this.toggle()}
          translate={translate}
          fillHeight
        >
          <div className={classes.bodyScroll}>
            {filterable ? (
              <SearchBar search={search} pager={pager} translate={translate}/>
            ) : null}{" "}
            <div className={classes.tableRegion}>
              <Table
                translate={translate}
                filterable
                managedViewportScroll
                pages={devices.pagecount}
                manual={pager.manual}
                defaultPageSize={pager.pagesize}
                data={devices.data}
                columns={this.state.columns}
                fetch={fetch}
                allowSelectOne={deleteEnabled}
                compactSelection
                selectedRows={this.selectedRows}
                selected={_selected}
                pager={pager}
                minRows={0}
                style={{
                  border: "none",
                  height: "100%"
                }}
                className={"deviceTable"}
                noDataText="no_devices_data"
              />{" "}
            </div>
          </div>
          {$modal}{" "}
          <ConfirmDialog
            open={this.state.showConfirmDelete}
            title={translate("device_delete_confirm_title")}
            contentText={confirmDeleteText}
            contentSecondaryText={translate("general_confirmation_help_2")}
            okText={translate("general_confirm")}
            cancelText={translate("general_cancel")}
            onOk={this.del}
            onCancel={this.hideConfirmDel}
          />{" "}
          {APP_CONFIG.deviceLockEnabled && <ConfirmDialog
            open={lockDevice.showModal}
            title={translate(
              lockDevice.isLocked ? "device_unlock_title" : "device_lock_title"
            )}
            contentText={translate(
              lockDevice.isLocked
                ? "device_unlock_confirm_text"
                : "device_lock_confirm_text"
            )}
            okText={translate("general_confirm")}
            cancelText={translate("general_cancel")}
            onOk={() => this.toggleLock()}
            onCancel={() => this.hideLockDeviceModal()}
          />} {" "}
          <HealthCheckModal
            isOpen={healthCheckModal.isOpen}
            deviceHealth={healthCheckModal.selectedDevice ? healthCheckModal.selectedDevice.deviceHealth : null}
            onOpenChange={this.handleHealthCheckOpenChange}
            translate={translate}
          />{" "}
        </Content>{" "}
      </div>
    );
  }

  selectedRows = rows => {
    const {devices} = this.props;
    let selectedDevices;
    selectedDevices = [];

    Object.keys(rows).map(key => {
      if (rows[key]) {
        selectedDevices.push(
          devices.data.find(x => x.id === parseInt(key, 10))
        );
      }
      return key;
    });

    this.setState({
      selectedDevices,
      selectAll: false,
      selected: rows
    });
  };

  toggle() {
    this.setState({
      contextMenu: !this.state.contextMenu
    });
  }

  toggleColumns(column) {
    let columns = [...this.state.columns];

    columns.forEach(c => {
      if (c.id === column.id) {
        c.show = column.show;
      }
    });
    this.setState({
      columns: columns
    });
  }

  toggleFilters = () => {
    let columns = [...this.state.columns];
    let {filterable} = this.state;
    columns.forEach(c => {
      c.filterable = c.cansearch && !filterable;
    });
    this.setState({
      columns: columns,
      filterable: !filterable
    });
  };

  getLinkedAdapters = deviceId => {
    const rows = this.props.adapterAssets && this.props.adapterAssets.data
      ? this.props.adapterAssets.data
      : [];

    return rows.filter(row => row.linkeddeviceid === deviceId);
  };

  renderLinkedAdapterCell = deviceId => {
    const { classes } = this.props;
    const linkedAdapters = this.getLinkedAdapters(deviceId);

    if (!linkedAdapters.length) {
      return <span>-</span>;
    }

    return (
      <div className={classes.linkedAssetsCell}>
        {linkedAdapters.map(adapter => (
          <div key={adapter.id} className={classes.linkedAssetItem}>
            <TestsRowLink
              title={adapter.adapterserialno}
              link={`/adapter/${encodeURIComponent(adapter.adapterserialno)}?from=devices`}
            />
          </div>
        ))}
      </div>
    );
  };
}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  profile: state.profileReducer.profile,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Devices);
